/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getAddressDecoder,
  getAddressEncoder,
  getStructDecoder,
  getStructEncoder,
  type Address,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from '@solana/kit';

export type RehypeInitialized = {
  rehypeState: Address;
  launch: Address;
  baseMint: Address;
  quoteMint: Address;
  hookProgram: Address;
};

export type RehypeInitializedArgs = RehypeInitialized;

export function getRehypeInitializedEncoder(): FixedSizeEncoder<RehypeInitializedArgs> {
  return getStructEncoder([
    ['rehypeState', getAddressEncoder()],
    ['launch', getAddressEncoder()],
    ['baseMint', getAddressEncoder()],
    ['quoteMint', getAddressEncoder()],
    ['hookProgram', getAddressEncoder()],
  ]);
}

export function getRehypeInitializedDecoder(): FixedSizeDecoder<RehypeInitialized> {
  return getStructDecoder([
    ['rehypeState', getAddressDecoder()],
    ['launch', getAddressDecoder()],
    ['baseMint', getAddressDecoder()],
    ['quoteMint', getAddressDecoder()],
    ['hookProgram', getAddressDecoder()],
  ]);
}

export function getRehypeInitializedCodec(): FixedSizeCodec<
  RehypeInitializedArgs,
  RehypeInitialized
> {
  return combineCodec(
    getRehypeInitializedEncoder(),
    getRehypeInitializedDecoder(),
  );
}
